import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";
import FeatureStrip from "@/components/sections/FeatureStrip";
import ExperienceSection from "@/components/sections/ExperienceSection";
import StayInLoop from "@/components/sections/StayInLoop";
import { IMG } from "@/lib/content";

export default function Experience() {
  return (
    <>
      <Seo title="The Experience — RestPower" description="Power up, fuel up, reset, and gear up. Every detail of the RestPower experience is designed around the traveler." path="/experience" />
      <PageHeader
        overline="The Experience"
        title={<>Every Detail. Every Stop.</>}
        intro="From fast, reliable charging to quality food, comfortable spaces, and a curated market — the RestPower experience is designed around the whole journey, not just the vehicle."
        image={IMG.exterior}
      />
      <ExperienceSection withCta={false} />
      <FeatureStrip />
      <StayInLoop />
    </>
  );
}
